import { createSelector } from '@ngrx/store';
import { OnlineOrders } from '@shared/core/utils';
import { historyOrdersState } from '../root';

export const getHistoryOrders = createSelector(historyOrdersState, (historyOrders) =>
    historyOrders.orders
        .filter((order) => order.data !== null && OnlineOrders.isOrderFinalized(order.data.Status) === true)
        .sort((a, b) => b.OrderId - a.OrderId),
);
